import React from "react";
import { Link } from "react-router-dom";
import { LOGO_IMAGE } from "../constants/assets";

export default function Logo({ size = "md" }) {
  const sizes = {
    sm: "h-8",
    md: "h-11",
    lg: "h-14",
  };
  const heightClass = sizes[size] || sizes.md;

  return (
    <Link to="/" className="inline-flex items-center leading-none select-none shrink-0">
      <img
        src={LOGO_IMAGE}
        alt="TV13"
        className={`${heightClass} w-auto object-contain`}
        decoding="async"
      />
    </Link>
  );
}
